var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.65 337.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.36,159.06a93.16,93.16,0,0,0,22.86-94.35,4.45,4.45,0,0,0-7.39-1.82L270.51,118.2c-14.31,14.32-38,14.59-52.06,0a36.11,36.11,0,0,1,.5-50.56l55.82-55.82A4.43,4.43,0,0,0,273,4.47,93.15,93.15,0,0,0,158.22,128.29h0L10.59,275.92a36.16,36.16,0,0,0,0,51.14h0a36.18,36.18,0,0,0,51.15,0L209.31,179.48A93.2,93.2,0,0,0,310.36,159.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.33ffb8cfef3724e39dc57ddff84c60c8.svg";
export { ForwardRef as ReactComponent };